import { useSyncExternalStore, useContext } from 'react';
import type { StoreApi } from 'zustand/vanilla';
import { StoreContext } from '../main';

const useStoreSelectorFrom = <T, S>(
  store: StoreApi<T>,
  selector: (s: T) => S
) => {
  const subscribe = (listener: () => void) => store.subscribe(listener);
  const getSnapshot = () => selector(store.getState());

  return useSyncExternalStore(subscribe, getSnapshot);
}

const useStoreSelector = <T, S>(selector: (s: T) => S) => {
  const store = useContext(StoreContext) as StoreApi<T> | null;
  if (!store) throw new Error('Store not provided');
  return useStoreSelectorFrom(store, selector);
}

export { useStoreSelectorFrom, useStoreSelector };
